module.exports = __webpack_public_path__ + "img/message_jing.7dd96430.png";